import _ from 'lodash'
import { keyframes } from 'styled-components'

import { FULLSCEEN_WIDTH_BREAKPOINT } from '../constants'

const make_createActionType = (prefix = 'DB_BOT_UI') => ( actionType = '') => {
  return `${prefix}/${actionType}`
}

let setters = {}

setters.string = function(path, value) {
  if (value === undefined ) return

  if (!_.isString(value)) {
    console.error(`Invalid ${this.constructor.name}.${path} : expected string but was ${typeof value}`)
    debugger
  } else {
    _.set(this, path, value)
  }
}

setters.bool = function(path, value) {
  if (value === undefined ) return

  if (!_.isBoolean(value)) {
    console.error(`Invalid ${this.constructor.name}.${path} : expected boolean but was ${typeof value}`)
    debugger
  } else {
    _.set(this, path, value)
  }
}

setters.object = function(path, value) {
  if (value === undefined ) return

  if (!_.isObject(value)) {
    console.error(`Invalid ${this.constructor.name}.${path} : expected object but was ${typeof value}`)
    debugger
  } else {
    _.set(this, path, value)
  }
}


setters.instanceOf = function(path, value, ...types) {
  if (!value) return

  if (types.some(Type => (value instanceof Type))) {
    _.set(this, path, value)
  } else {
    console.error(`Invalid ${this.constructor.name}.${path} : expected one of ${types.map(t => t.name).join(', ')} but was ${typeof value}`)
    debugger
  }
}

setters.arrayOfType = function(path, value, Type) {
  if (!value) return

  if (!_.isArray(value)) {
    console.error(`Invalid ${this.constructor.name}.${path} : expected array but was ${typeof value}`)
    debugger
  } else {
    let arr = []

    value.forEach((val) => {
      if (val instanceof Type) {
        arr.push(val)
      } else {
        console.error(`Invalid ${this.constructor.name}.${path} array value: expected ${Type.name} but was ${typeof val}`)
        debugger
      }
    })
    _.set(this, path, arr)
  }
}


setters.arrayOfPrimitives = function(path, value, type) {
  if (!value) return

  if (!_.isArray(value)) {
    console.error(`Invalid ${this.constructor.name}.${path} : expected array but was ${typeof value}`)
    debugger
  } else {
    let arr = []

    value.forEach((val) => {
      if (typeof val === type) {
        arr.push(val)
      } else {
        console.error(`Invalid ${this.constructor.name}.${path} array value: expected ${type} but was ${typeof val}`)
        debugger
      }
    })
    _.set(this, path, arr)
  }
}

const addTargetBlank = str => {
  if (!str) { return }
  return str.replace(/<a\s+href\s*?=/g, '<a target="_blank" href=')
}


const addMessageListener = (type, callback) => {
  const listenerFn = e => {
    if (e.data.type === type) {
      callback(e.data)
    }
  }

  window.addEventListener('message', listenerFn)
  return () => window.removeEventListener('message', listenerFn)
}

const luminanace = (r, g, b) => {
  var a = [r, g, b].map(v => {
    v /= 255
    return v <= 0.03928
      ? v / 12.92
      : Math.pow( (v + 0.055) / 1.055, 2.4 )
  })
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

const contrast = (hex1, hex2) => {
  const rgb1 = hexToRgb(hex1)
  const rgb2 = hexToRgb(hex2)
  const r1 = rgb1.split(',')
  const r2 = rgb2.split(',')

  return (luminanace(r1[0], r1[1], r1[2]) + 0.05)
    / (luminanace(r2[0], r2[1], r2[2]) + 0.05)
}

const hexToRgb = (hex) => {
  var c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = '0x' + c.join('')
    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')
  }
  throw new Error('Bad Hex')
}

const blinkBuilder = (color) => {
  const blink = keyframes`
  0% {
    outline: transparent solid 3px;
  }
  50% {
  outline: ${color} solid 3px;
    }
  100% {
    outline: transparent solid 3px;
    }
`
  return blink
}

const getNotes = () => sessionStorage.getItem('notes')


const isFullScreen = () => (
  window.innerWidth < FULLSCEEN_WIDTH_BREAKPOINT
)

const getUrlParameterByName = name => {
  const params = window.location.search.slice(1).split('?').reduce((acc, s) => {
    const [k, v] = s.split('=')
    return Object.assign(acc, {[k]: v})
  }, {})
  return params[name]
}

export {
  make_createActionType,
  setters,
  addTargetBlank,
  addMessageListener,
  contrast,
  blinkBuilder,
  getNotes,
  isFullScreen,
  getUrlParameterByName
}



// WEBPACK FOOTER //
// ./src/helpers/index.js